import RadioButton from '@src/components/common/radioButton/RadioButton';
import { TFilterTag } from '@src/types/weddingHallFilter';
import { HALL_FILTER_DATA } from '@src/utils/weddingHall';

type Item = typeof HALL_FILTER_DATA[keyof typeof HALL_FILTER_DATA][number];
interface IRadioItems {
  items: Item[];
  onSelect: (value: TFilterTag) => void;
  tags: TFilterTag[];
}
const RadioItems = ({items, onSelect, tags}: IRadioItems) => {
	return (
		<div>
			<ul className="radio-list-wrap">
				{items.map((type, idx) => (
					<li key={`radio-list-${type.key}-${type.name}`}>
						<RadioButton 
							id={`${type.key}-radio-${type.value}-${idx}`}
							name="hallLevel"
							value={type.value as string}
							setValue={_ => {
								const value: TFilterTag = {
									name: type.name,
									typeName: type.typeName,
									paramName: type.key as string,
									value: type.value
								}
                onSelect(value);
              }}
							checked={tags?.some(tag => (tag.value === type.value && tag.typeName === type.typeName))}
						/>
						<label htmlFor={`${type.key}-radio-${type.value}-${idx}`}>{type.name}</label>
					</li>
				))}
			</ul>
		</div>
	);
};

export default RadioItems;